module.exports = __webpack_public_path__ + "static/headinclouds-3a4f9abb62c4fe816aeaeb3cb00efda9.jpg";